import React from "react";
import {
  FaHotel,
  FaFileSignature,
  FaClipboardList,
  FaUserTie,
} from "react-icons/fa";

const BULLETS = [
  {
    icon: FaHotel,
    text: "חיפוש מלונות וחבילות במקום אחד",
  },
  {
    icon: FaFileSignature,
    text: "הצעות מחיר ללקוח בלי לבנות מסמך מאפס",
  },
  {
    icon: FaClipboardList,
    text: "ניהול הזמנות מסודר — פחות בלבול בין עסקאות",
  },
  {
    icon: FaUserTie,
    text: "מראה מקצועי מול לקוח בכל שלב",
  },
];

/** דמו מינימלי — שפת צבעים כמו עמוד הבית */
function AsideMockup() {
  return (
    <div className="agent-register-mock" aria-hidden>
      <div className="agent-register-mock__chrome">
        <span />
        <span />
        <span />
      </div>
      <div className="agent-register-mock__body">
        <div className="agent-register-mock__side" />
        <div className="agent-register-mock__main">
          <div className="agent-register-mock__kpiRow">
            <span />
            <span />
            <span />
          </div>
          <div className="agent-register-mock__panel" />
        </div>
      </div>
    </div>
  );
}

export default function AgentRegisterBenefits() {
  return (
    <div className="agent-register-benefits">
      <p className="agent-register-benefits__eyebrow">HotelsRiver לסוכנים</p>
      <h2 className="agent-register-benefits__title">למה כדאי להצטרף עכשיו</h2>
      <p className="agent-register-benefits__lead">
        המערכת שמרכזת חיפוש, הצעות והזמנות — כדי שתוכלו למכור בביטחון ולנהל בלי כאוס.
      </p>
      <ul className="agent-register-benefits__list">
        {BULLETS.map(({ icon: Icon, text }) => (
          <li key={text} className="agent-register-benefits__item">
            <span className="agent-register-benefits__icon">
              <Icon aria-hidden />
            </span>
            <span>{text}</span>
          </li>
        ))}
      </ul>
      <AsideMockup />
    </div>
  );
}
